import React from 'react';

/**
 * @typedef {object} OrgUnitBreadcrumbAnnotationProps
 * @property {Object} [orgUnit]
 */

/**
 * @param {OrgUnitBreadcrumbAnnotationProps} props
 */
const OrgUnitBreadcrumbAnnotation = props => {
  const { orgUnit } = props;

  if (!orgUnit) return null;

  const status = !orgUnit.IsActive && orgUnit.Name ? <strong> - De-Enrolled</strong> : '';

  return (
    <span>
      {orgUnit.Name}
      {status}
    </span>
  );
};

export default OrgUnitBreadcrumbAnnotation;
